import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'
import SmallButton from '@/components/buttons/SmallButton.vue'
import IxRouterLink from '@/components/navigation/IxRouterLink.vue'
import snippets from '@/content/snippets.js'
import constants from '@/constants.js'
import ixrouter from '@/components/navigation/ixrouter.js'
import Vue2TouchEvents from 'vue2-touch-events'
import apix from '@/api.js'
import './registerServiceWorker'

Vue.use(Vue2TouchEvents)

Vue.component('small-button', SmallButton)
Vue.component('ix-router-link', IxRouterLink)
Vue.prototype.$nippets = snippets
Vue.prototype.$k = constants
Vue.prototype.$ixr = ixrouter
Vue.prototype.$apix = apix

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
